import 'antd/dist/antd.css';
import React from 'react'
import {HashRouter, Route, Switch} from "react-router-dom";
import BasLogin from "./containers/BasLogin";
import {BasWechatBind} from "./containers/BasWechatBind";
import {IntlProvider} from 'react-intl'
import {useQueryParams} from "./hooks/useQueryParams";
import {enUs} from "./i18n/en-us";
import {zhCn} from "./i18n/zh-cn";
import {koKr} from "./i18n/ko-kr";
import {jaJp} from "./i18n/ja-jp";

function App() {
    const queryParams: any = useQueryParams();
    let messages;
    switch (queryParams?.locale) {
        case 'en-us':
            messages = enUs
            break;
        case 'zh-cn':
            messages = zhCn
            break;
        case 'ko-kr':
            messages = koKr
            break;
        case 'ja-jp':
            messages = jaJp
            break;
        default:
            messages = {}
            break;
    }
    return (
        <IntlProvider messages={messages} locale={queryParams?.locale}>
            <HashRouter>
                <Switch>
                    <Route path="/" exact component={BasLogin}/>
                    <Route path="/bas-wechat-bind" exact component={BasWechatBind}/>
                    <Route path="/bas" exact component={BasLogin}/>
                </Switch>
            </HashRouter>
        </IntlProvider>
    );
}

export default App;
